import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Table } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import { debounce, rangePresets } from '../../../../common/utils/common.utils';
import usePagination from '../../../../common/utils/usePagination';
import useUrlParams from '../../../../common/utils/useUrlParams';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import { FormInput } from '../../../../components/common/FormItem/FormItems';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import Reload from '../../../../components/common/reload/Reload';
import { loadingIndicator } from '../../../../components/common/spinner/LoadingIndicator';
import { formatDateRangeArray, parseDateRangeObject } from '../../../../helpers/healper';
import { useGetAllAuthorityQuery } from '../../Api/Endpoints/AuthorityEndpoints';
import { LoanAuthorityDataType } from '../../LoanTypes/LoanTypes';
import AddAuthorityModal from '../../Modals/Authority/AddAuthorityModal';
import EditAuthorityModal from '../../Modals/Authority/EditAuthorityModal';
import { ViewAuthorityList } from '../../Utils/Authority/ViewAuthorityList';

const ListAuthority = ({ permission }: perProps) => {
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const { setUrlParam, getAllUrlParams, setUrlParamsFromObject } = useUrlParams();
  const { page, size, changePagination, pagination } = usePagination();
  const params_value = getAllUrlParams() as {
    search: string | null;
    from_date: string | null;
    to_date: string | null;
  };

  const [editInfo, setEditInfo] = useState<LoanAuthorityDataType | null>(null);

  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    data,
    isFetching,
    refetch: getAllRefetch,
    isLoading: dataIsLoading,
  } = useGetAllAuthorityQuery({
    ...getAllUrlParams(),
    page,
    size,
  });
  // Add safety check for data mapping
  const dataWithKey =
    data?.data?.map((item, index) => ({
      key: String(index),
      ...item,
    })) || [];
  const handelSearch = useCallback(
    debounce((e: string) => {
      setUrlParam('search', e);
    }, 600),
    []
  );

  useEffect(() => {
    form.setFieldsValue({
      search: params_value.search || '',
      date_range: parseDateRangeObject({
        from_date: params_value.from_date,
        to_date: params_value.to_date,
      }),
    });
  }, [params_value]);
  return (
    <div>
      <BreadCrumb arrOfOption={['Loan Management', 'Authority List']} reloaderSize='small' />

      <Row justify={'space-between'} gutter={[10, 10]}>
        <Col span={12}>
          <Row gutter={10}>
            {permission?.['create:any'] && (
              <Col xs={24} sm={12} md={8} lg={8}>
                <Button
                  onClick={showModal}
                  type='primary'
                  icon={<PlusOutlined />}
                  style={{ width: '100%' }}
                >
                  Create
                </Button>
              </Col>
            )}

            <Col xs={24} sm={12} md={8} lg={8} style={{ display: 'flex' }}>
              <Col>
                <Reload
                  refetch={() => {
                    getAllRefetch();
                  }}
                />
              </Col>
            </Col>
          </Row>
        </Col>

        <Col span={12}>
          <Form form={form}>
            <Row justify={'end'} gutter={[10, 10]}>
              <Col xs={24} sm={12} md={8} lg={8}>
                <DatePicker.RangePicker
                  name={'date_range'}
                  presets={rangePresets}
                  format={'YYYY-MM-DD'}
                  onChange={(e: any) => setUrlParamsFromObject(formatDateRangeArray(e))}
                />
              </Col>
              <FormInput
                name={'search'}
                placeholder='Search here ...'
                onChange={(e: string) => handelSearch(e.trim())}
              />
            </Row>
          </Form>
        </Col>
      </Row>

      <CommonTableHeader
        title=''
        modalTitle={editInfo ? 'Edit Authority' : 'Add Authority'}
        element={
          editInfo ? (
            <EditAuthorityModal info={editInfo} setNull={setEditInfo} />
          ) : (
            <AddAuthorityModal />
          )
        }
        setNull={setEditInfo}
      />
      <div>
        <span style={{ marginLeft: '5px', float: 'left', marginBottom: '1rem' }}>
          You have total <strong>{data?.count || data?.data?.length || 0}</strong> rows.
        </span>
        <Table
          size='small'
          bordered
          columns={ViewAuthorityList({
            setEditInfo,
            showModal,
            permission,
            pagination,
          })}
          pagination={changePagination(data?.count)}
          dataSource={dataWithKey}
          scroll={{ x: true }}
          loading={{
            spinning: dataIsLoading || isFetching,
            indicator: loadingIndicator,
          }}
        />
      </div>
    </div>
  );
};

export default ListAuthority;
